"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLASSIFY_RETIVUT_OLD_SYSTEM_PROMPT = void 0;
const CLASSIFY_RETIVUT_OLD_SYSTEM_PROMPT = (places, defectsTitles) => `Analyze the photo with red markings. Using frequency counts (numbers in parentheses):

1. From Places: ${places}
   Select exactly 3 most relevant locations.

2. From LeakIndicators: ${defectsTitles}
   Select exactly 5 most critical issues.

3. If a hygrometer is visible in the photo:
   - Note if readings indicate high (wet) or low (dry) moisture levels
   - Factor this into your assessment of water damage and leak risks

Focus on water damage, active leaks, and potential leak sources. Use hygrometer readings if available to validate moisture concerns.`;
exports.CLASSIFY_RETIVUT_OLD_SYSTEM_PROMPT = CLASSIFY_RETIVUT_OLD_SYSTEM_PROMPT;
